import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-privacy-principles-modal",
  imports: [],
  templateUrl: "./privacy-principles-modal.component.html",
  styleUrls: ["./privacy-principles-modal.component.scss"],
})
export class PrivacyPrinciplesModalComponent {
  constructor(private readonly matDialog: MatDialog) {}

  protected close() {
    this.matDialog.closeAll();
  }

  protected downloadFile() {
    window.open("assets/documents/Allianz_Privacy_Standard_v1.pdf", "_blank");
  }
}
